var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vc-order-back-to-store-button button is-outlined is-odd back-to-store",on:{"click":_vm.backToStore}},[_vm._v(_vm._s(_vm.actionLocaleText('back_to_store')))])}
var staticRenderFns = []

export { render, staticRenderFns }